import { useMessage } from "../context/message/message-context"

export const useMiscFunctions = () => {
    const { showMessage } = useMessage()

    const copyToClipboard = async (text: string, successText?: string) => {
        try {
            const message = 'Copiado!'

            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text)
                showMessage(successText ?? message, { type: 'success' })
                return
            }

            // Fallback para navegadores antigos
            const textarea = document.createElement('textarea')
            textarea.value = text
            textarea.setAttribute('readonly', '')
            document.body.appendChild(textarea)

            textarea.select()
            const success = document.execCommand('copy')
            document.body.removeChild(textarea)

            if (success)
                showMessage(successText ?? message, { type: 'success' })
            else
                throw new Error('Copy fallback error.')

        }
        catch (err) {
            showMessage('Erro ao copiar o texto.', { type: 'danger', error: err as Error })
        }
    }

    return { copyToClipboard }
}